// Ensure GSAP and ScrollTrigger are loaded
gsap.registerPlugin(ScrollTrigger);

// Define different scroll trigger for different screen sizes
ScrollTrigger.matchMedia({
  // For screens wider than 768px (e.g., desktop)
  "(min-width: 768px)": function () {
    gsap.to("#bike", {
      x: "150vw", // Move the bike across the screen
      scrollTrigger: {
        trigger: "#test-ride", // Trigger animation when scrolling this section
        start: "top -50%", // Start when the section hits the top of the viewport
        end: "bottom top", // End when the bottom of the section hits the top of the viewport
        scrub: 0.2, // Smooth animation tied to scroll position
      },
    });
  },

  // For screens smaller than 768px (e.g., mobile)
  "(max-width: 767px)": function () {
    gsap.to("#bike", {
      x: "150vw", // Move the bike across the screen
      scrollTrigger: {
        trigger: "#test-ride", // Trigger animation when scrolling this section
        start: "top -50%", // Start when the section hits 30% of the viewport (for mobile)
        end: "bottom top", // End when the bottom of the section hits the top of the viewport
        scrub: 0.2, // Smooth animation tied to scroll position
      },
    });
  },
});
